const LOCAL_TOKEN_KEY = 'NEWSROOM_AUTH';
const LOCAL_USER_DATA = 'NEWSROOM_USER_DATA';

export const getUserData = token => fetch(`${process.env.REACT_APP_API_HOST}/api/v1/me/?token=${token}`);

export const saveLocalToken = (token) => {
  localStorage.setItem(LOCAL_TOKEN_KEY, token);
};

export const saveLocalUser = (data) => {
  localStorage.setItem(LOCAL_USER_DATA, JSON.stringify(data));
};

export const getLocalUser = () => JSON.parse(localStorage.getItem(LOCAL_USER_DATA));

export const clearAuthSession = () => {
  localStorage.removeItem(LOCAL_TOKEN_KEY);
};

export const getLocalToken = () => localStorage.getItem(LOCAL_TOKEN_KEY);



// WEBPACK FOOTER //
// ./src/helpers/auth.js